import { useCallback, useState } from "react";

import type { ModalButtonComponentProps } from "../types/GenericConfirmationButtonProps";

export const useConfirmationButtonHandler = (props: ModalButtonComponentProps) => {
    const {
        isDisabled, // the button is displayed but not clickable by the user
        onClickCallback, // when the user clicks the button this callback is called
        item, // the item subject of this action button, used in the callback as context
        modalTitle, // the title translation key to be shown in the confirmation dialog
        modalBody, // the content translation  key to be shown in the confirmation dialog
        translationKey, // the button translation key
        params, // the translation key params to be used when a translation key has paramaters
        name,
    } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);

    const requestUserConfirmation = useCallback(() => {
        setIsModalVisible(true);
    }, [setIsModalVisible]);

    const onOk = useCallback(() => {
        setIsModalVisible(false);
        onClickCallback(item);
    }, [onClickCallback, item, setIsModalVisible]);

    const onCancel = useCallback(() => {
        setIsModalVisible(false);
    }, [setIsModalVisible]);

    return [
        name,
        isModalVisible,
        onOk,
        onCancel,
        requestUserConfirmation,
        modalTitle,
        modalBody,
        params,
        isDisabled,
        translationKey,
    ] as const;
};
